var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-badge",class:("ui-badge--" + _vm.resolvedTone)},[(_vm.dot)?_c('span',{staticClass:"ui-badge__dot"}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.resolvedText))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }